/* @flow */
import { OrderedMap, Record } from 'immutable';

import { shasum } from 'trustar/utils/utils.js';
import { ADD_ALERT, DELETE_ALERT } from './action-types.js';
import type { AlertObject } from './constants.js';

export const Alert = Record({
  id: '',
  type: '',
  text: '',
  htmlMessage: null,
});

/**
 * getKey returns a string value that is unique to any given object with both
 * text and type properties. We use this to ensure that alert sare unique
 * in terms of type and text combination.
 */
export const getKey = ({ type, text }: AlertObject): string => shasum(type + text);

/**
 * When adding a alert we don't want to allow duplicates. Duplicates are
 * defined as a alert with the same text AND type. Meaning you can add an
 * error alert with text 'hey' and a warning with text 'hey'. That's
 * fine, but we want alerts to be unique in terms of text/type
 * combination.
 *
 * For this purpose we has the concatenation of alert.type and
 * alert.text and use the resulting hashed value as they key for this
 * alert. See `getKey` for more info.
 *
 * NOTE: Although we call the key 'id', alerts are never persisted to the
 * server. They are in-memory only.
 *
 * NOTE: That when creating alerts a plain object is dispatched and
 * handled by the store. On the other hand, when deleting a alert we get
 * an immutable map since it has already be converted.
 */
type State = OrderedMap<string, Alert>;

export default (state: State = OrderedMap(), action: Object) => {
  const { type, payload } = action;

  switch (type) {
  case ADD_ALERT:
    const id = getKey(payload);
    return state.set(id, Alert({ id, ...payload }));
  case DELETE_ALERT:
    return state.delete(payload.get('id'));
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/modules/alerts/stores.js